module.exports = __webpack_public_path__ + "img/footer.54c9d5fe.png";